var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { uniq } from 'lodash';
import { uuid } from '../../shared/uuid';
import { mergeSceneGraphs, updateChapterShowSelectPickThroughObjects } from './merge-scene-graph';
import { updateParticleSystems } from './merge-particle-systems';
import { mergeColorRecipes, updateChapterColorRecipes } from './merge-color-recipes';
import { mergeReflections } from './merge-reflections';
import { mergeAssetLibraries } from './merge-asset-libraries';
import { setLightsForChapters } from './merge-lights';
export function mergeModules(currentStory, currentStoryId, newStory, newStoryId, exportType, prefixUuidFunc) {
    if (exportType === void 0) { exportType = 'bookmark'; }
    if (prefixUuidFunc === void 0) { prefixUuidFunc = uuid.idWithPrefix; }
    // start by merging global properties
    var _a = mergeSceneGraphs(currentStory.sceneGraph, newStory.sceneGraph), sceneGraph = _a.sceneGraph, graphsMerged = _a.graphsMerged, objectIdsUniqueToNew = _a.objectIdsUniqueToNew, objectIdsUniqueToOriginal = _a.objectIdsUniqueToOriginal;
    var assetLibraries = mergeAssetLibraries(currentStory.assetLibraries, newStory.assetLibraries);
    var reflections = mergeReflections(currentStory.reflections, newStory.reflections, currentStoryId, newStoryId);
    var _b = mergeColorRecipes(currentStory.colorRecipes, newStory.colorRecipes, prefixUuidFunc), colorRecipes = _b.colorRecipes, newColorRecipeIds = _b.newColorRecipeIds;
    // then merge chapter properties
    var currentChaptersUpdatedLights = setLightsForChapters(currentStory.chapters, currentStory.assetLibraries.lights);
    var newChaptersUpdatedLights = setLightsForChapters(newStory.chapters, newStory.assetLibraries.lights);
    var currentChaptersUpdatedProps = updateChapterShowSelectPickThroughObjects(currentChaptersUpdatedLights, graphsMerged, objectIdsUniqueToNew);
    var newChaptersUpdatedProps = updateChapterShowSelectPickThroughObjects(newChaptersUpdatedLights, graphsMerged, objectIdsUniqueToOriginal);
    // give imported chapters a new id
    var importedChaptersWithNewIds = newChaptersUpdatedProps.map(function (c) {
        return __assign({}, c, { id: prefixUuidFunc('chapter') });
    });
    var currentParticleSystemUpdates = updateParticleSystems(currentChaptersUpdatedProps, (currentStory.customData || {}).particleSystems || []);
    var importedParticleSystemUpdates = updateParticleSystems(importedChaptersWithNewIds, (newStory.customData || {}).particleSystems || []);
    var importedChaptersWithUpdatedColorRecipes = updateChapterColorRecipes(importedParticleSystemUpdates.chapters, newColorRecipeIds);
    var chapters = __spread(currentParticleSystemUpdates.chapters, importedChaptersWithUpdatedColorRecipes);
    // TODO: what types of customData besides ParticleSystems am I throwing out from imported modules?
    var customData = __assign({}, currentStory.customData, { particleSystems: __spread(currentParticleSystemUpdates.particleSystemsForCustomData, importedParticleSystemUpdates.particleSystemsForCustomData) });
    var tags = exportType === 'module' ? currentStory.tags : [];
    return __assign({}, currentStory, { assetLibraries: assetLibraries,
        chapters: chapters,
        sceneGraph: sceneGraph,
        customData: customData,
        tags: tags,
        reflections: reflections,
        colorRecipes: colorRecipes, stateId: uniq(__spread(currentStory.stateId, newStory.stateId)) });
}
